<template>
  <div class="RaUEbannerBox">
    <div class="con">
      <div class="banner">
        <el-carousel trigger="click" height="430px" :interval="interval">
          <el-carousel-item
            v-for="(item, index) in bannerList"
            :key="index"
            v-show="item.status"
          >
            <!-- 假如图片有指定连接才可以点击跳转 -->
            <a :href="item.href_url" v-if="item.href_url">
              <img :src="item.img_url" alt="" class="bannerImg" />
            </a>
            <img :src="item.img_url" alt="" class="bannerImg" v-else />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="rightBox">
        <div
          class="rightItem email"
          @click="$fun.routerToPage('mailto:service@rakumart.it', true)"
        >
          <img :src="require('@/assets/home/email.svg')" alt="" />
          <span>service@rakumart.it</span>
        </div>
        <div
          class="rightItem youtube"
          @click="
            $fun.routerToPage('https://www.youtube.com/@Rakumart-Italy', true)
          "
        >
          <div class="flex acenter">
            <img :src="require('@/assets/home/youtube.svg')" alt="" />
            <span class="youtubeName"
              >Canal: <span class="red">Rakumart-Italy</span></span
            >
          </div>
          <div class="fontBox">
            {{ $fanyi("你可以通过 YouTube 频道了解更多信息。") }}
          </div>
        </div>
        <div class="rightItem time">
          <div class="flex astart">
            <img :src="require('@/assets/home/time.svg')" alt="" />
            <span class="timeName"> {{ $fanyi("中国营业时间") }}</span>
          </div>
          <div class="timeRange pale">
            <!-- 意大利时间 03:00-12:00 -->
            {{ $fanyi("意大利时间 03:00-12:00") }} <br />
            {{ $fanyi("中国时间 09:00-18:00") }}
          </div>
          <div class="pale smallFontBox">
            ({{ $fanyi("除星期六、星期日和中国法定节假日外") }})
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      bannerList: [],
      interval: 5000,
      lists: [],
      showMore: false, //是否显示11个分类以外的分类
    };
  },
  components: {},
  computed: {},
  created() {
    this.getShopBanner();
  },

  methods: {
    // 显示更多分类
    showClassMore() {
      this.showMore = !this.showMore;
    },
    loginOut() {
      localStorage.removeItem("backgroundOperationID");
      sessionStorage.removeItem("backendPersonnel");
      localStorage.removeItem("user_token");
      sessionStorage.removeItem("user_id");

      this.$store.commit("userData", null);
      this.$store.commit("setcartCount", 0);
      let requireAuth = this.$route.matched[0].meta.requireAuth;
      if (requireAuth) {
        this.$fun.routerToPage("/");
      }
    },
    getShopBanner() {
      this.$api.getShopBanner().then((res) => {
        this.interval = res.data.switch_time * 1000;
        this.bannerList = res.data.list;
      });
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "../../css/mixin";

.RaUEbannerBox {
  padding: 30px 0 54px;
  background-color: #fafafa;

  .con {
    margin: 0 auto;
    width: $pageWidth;
    display: flex;

    .banner {
      flex: 1;

      .bannerImg {
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }

      // margin: 20px 30px 0 20px;
      // 轮播图两侧样式
      /deep/.el-carousel__arrow--right,
      /deep/.el-carousel__arrow--left {
        width: 41px;
        height: 41px;
        background: rgba(0, 0, 0, 0.3) !important;
        opacity: 0.75;
        border-radius: 50%;
        font-size: 13px;

        i {
          font-size: 18px !important;
        }

        &:hover {
          opacity: 1;
        }
      }

      /deep/ .el-carousel__arrow {
        background: rgba(255, 255, 255, 0.5);
        text-align: center;

        i {
          color: white;
          font-size: 23px;
          font-weight: 700;
        }
      }

      /deep/.el-carousel__button {
        width: 10px;
        height: 10px;
        background: #ffffff;
        border-radius: 50%;
      }

      /deep/.el-carousel__indicator.el-carousel__indicator--horizontal {
        .el-carousel__button {
          background: rgba(255, 255, 255, 0.5);
        }
      }

      /deep/.el-carousel__indicator.el-carousel__indicator--horizontal.is-active
        .el-carousel__button {
        background: #009246;
      }
    }

    .rightBox {
      margin-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 12px;

      .rightItem {
        border-radius: 10px;
        width: 350px;
        padding: 20px;
        display: flex;
        align-items: center;
        background: #ffffff;
        border: 1px solid #dedede;

        img {
          margin-right: 12px;
        }
      }

      .email {
        color: #009246;
        cursor: pointer;

        span {
          font-size: 18px;
          font-weight: bold;
          line-height: 26px;
        }
      }

      .youtube {
        flex-direction: column;
        align-items: flex-start;
        cursor: pointer;

        .youtubeName {
          font-size: 18px;
          font-weight: bold;

          .red {
            color: #fe0000;
          }
        }

        .fontBox {
          color: #000000;
          padding-left: 52px;
          font-size: 14px;
          line-height: 22px;
        }
      }

      .time {
        flex-direction: column;
        align-items: flex-start;
        color: #000;

        .timeName {
          font-size: 16px;
          font-weight: 600;
        }

        .pale {
          padding-left: 52px;
        }

        .timeRange {
          margin-top: 6px;
          font-size: 18px;
          font-weight: bold;
          line-height: 26px;
          color: #fdc100;
          margin-bottom: 12px;
        }

        .smallFontBox {
          font-size: 14px;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
